import React, { useMemo } from 'react';
import { Box } from '@availity/element';

import { useAppContext } from '@/context';
import { NextStepsExistingOrganization, NextStepsOrgNeedsAdmin, NextStepsStart } from '@/pages';

const NextSteps = () => {
  const { currentNextStepsPage } = useAppContext();

  const pageToDisplay = useMemo(() => {
    let component;

    switch (currentNextStepsPage) {
      case 'existingOrg': {
        component = <NextStepsExistingOrganization />;
        break;
      }
      case 'newOrgNeedsAdmin': {
        component = <NextStepsOrgNeedsAdmin />;
        break;
      }
      default: {
        component = <NextStepsStart />;
      }
    }

    return component;
  }, [currentNextStepsPage]);

  return <Box role="main">{pageToDisplay}</Box>;
};

export default NextSteps;
